import { render, staticRenderFns } from "./DownIcon.vue?vue&type=template&id=d8d61306&"
import script from "./DownIcon.vue?vue&type=script&lang=js&"
export * from "./DownIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports